import { Company } from '~/types/company';
import { MetaDataCursorPage } from '~/types/jsonapi';

export const CategoryQueryKeys = {
  company: (companyId: string) => ['Categories', companyId],
  single: (companyId: string, id: string) => ['Categories', companyId, 'Single', id],
  infinite: (companyId: string) => ['Categories', companyId, 'Infinite'],
  infiniteSearch: (companyId: string, filter: CategorySearchFilter) => ['Categories', companyId, 'Infinite', filter],
};

export const CategoryResourceType = 'category';

export interface CategoriesMeta {
  page: MetaDataCursorPage;
  total: number;
}

export interface Category {
  id: string;
  name: string;
  color: string;
  subcategories?: Subcategory[];
}

export interface CategoryCreate {
  name: string;
  color: string;
  subcategories?: Subcategory[];
  company: {
    id: Company['id'];
  };
}

export interface CategoryUpdate {
  name: string;
  color: string;
}

export interface CategorySearchFilter {
  search: string;
}

export const SubcategoryQueryKeys = {
  company: (companyId: string) => ['Subcategories', companyId],
  all: (companyId: string) => ['Subcategories', companyId, 'all'],
  category: (companyId: string, categoryId: string) => ['Subcategories', companyId, 'category', categoryId],
  infiniteSearch: (companyId: string, filter: SubcategorySearchFilter) => [
    'Subcategories',
    companyId,
    'Infinite',
    filter.categoryId,
    filter.search,
  ],
};

export const SubcategoryResourceType = 'subcategory';

export interface SubcategoriesMeta {
  page: MetaDataCursorPage;
  total: number;
}

export interface Subcategory {
  id: string;
  name: string;
  category: {
    id: Category['id'];
  };
}

export interface SubcategoryCreate {
  name: string;
  company: {
    id: Company['id'];
  };
  category: {
    id: Category['id'];
  };
}

export interface SubcategorySearchFilter {
  search: string;
  categoryId: Category['id'];
}

export interface SubcategoryUpdate {
  name: string;
}

export type CategoryFilterValue =
  | {
      type: 'uncategorized';
    }
  | {
      type: 'categories';
      categoryId: string[];
    }
  | {
      type: 'category_without_subcategories';
      categoryId: string;
    }
  | {
      type: 'subcategories';
      categoryId: string;
      subcategoryId: string[];
    };

export type OnErrorParams = { type: 'UNPROCESSABLE_CONTENT_ERROR'; message: string } | { type: 'GENERIC_ERROR' };
